export default __webpack_public_path__ + "static/2-4699cba131f5a6a617e3852b64d92ea2.png";